import { Grid, Link, Paper, Typography } from "@mui/material";

export default function Policies() {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant={"h3"} color={"primary.main"}>
          Policies
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={4}>
        <Paper sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Link
                color="secondary.main"
                href={
                  "https://thoughtworks.atlassian.net/wiki/spaces/POLICY/pages/271384608/Laptop+policy+-+Global"
                }
                target="_blank"
                rel="noreferrer"
                sx={{
                  textDecoration: "none",
                  "&:hover": {
                    fontWeight: "600",
                  },
                }}
              >
                Laptop Policy
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="secondary.main"
                href={
                  "https://thoughtworks.atlassian.net/wiki/spaces/POLICY/pages/271712271/Global+Information+Security+Policy+-+Systems+and+Functions"
                }
                target="_blank"
                rel="noreferrer"
                sx={{
                  textDecoration: "none",
                  "&:hover": {
                    fontWeight: "600",
                  },
                }}
              >
                End-Point Security Policy
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                color="secondary.main"
                href={
                  "https://thoughtworks.atlassian.net/wiki/spaces/POLICY/pages/271745034/Procurement+Policy+-+Global"
                }
                target="_blank"
                rel="noreferrer"
                sx={{
                  textDecoration: "none",
                  "&:hover": {
                    fontWeight: "600",
                  },
                }}
              >
                Hardware Procurement Policy
              </Link>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}
